import type {FC} from 'react';
import {
  Create,
  Datagrid,
  DeleteButton,
  Edit,
  EditButton,
  email,
  List,
  required,
  SimpleForm,
  TextField,
  TextInput,
} from 'react-admin';

export const AppraiserList: FC = () => (
  <List>
    <Datagrid rowClick="edit">
      <TextField source="name" />
      <TextField source="internalId" label="Internal ID" />
      <TextField source="phoneNumber" label="Phone" />
      <TextField source="email" />
      <TextField source="createdAt" label="Created" />
      <TextField source="updatedAt" label="Updated" />
      <EditButton />
      <DeleteButton />
    </Datagrid>
  </List>
);

export const AppraiserEdit: FC = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="name" validate={[required()]} />
      <TextInput source="internalId" label="Internal ID" />
      <TextInput source="phoneNumber" label="Phone" />
      <TextInput source="email" validate={[email()]} />
    </SimpleForm>
  </Edit>
);

export const AppraiserCreate: FC = () => (
  <Create>
    <SimpleForm>
      <TextInput source="name" validate={[required()]} />
      <TextInput source="internalId" label="Internal ID" />
      <TextInput source="phoneNumber" label="Phone" />
      <TextInput source="email" validate={[email()]} />
    </SimpleForm>
  </Create>
);
